import BaseModel from 'models/base-model';

export default class SourceStatementParams extends BaseModel({
  projectId: null,
  statementId: null,
  revisionId: null,
  readOnly: false,
  documentProcessType: 1,
}) {}
